export default "__VITE_ASSET__4daed589__"